import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Text, IconCheckCircleOutline, Badge, TextLinkButton } from '@machobear/design-system'
import { useListingData } from '../../../context/listing-data'
import { useListingDashboardModals } from '../../../modals'
import { InsightBlock } from '../insight-block'

const TitleContainer = styled.div`
  height: 21px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`

export const ActiveSponsor = () => {
  const { t } = useTranslation()

  const { currentSponsorship } = useListingData()
  const { showModal } = useListingDashboardModals()

  const end = new Date(currentSponsorship?.planned_end_date)
  const now = new Date()

  const remainingDays = Math.round((end.getTime() - now.getTime()) / 1000 / 60 / 60 / 24)

  return (
    <InsightBlock
      testId="boost-listing"
      icon={<IconCheckCircleOutline tone="positive" size="small" />}
    >
      <TitleContainer>
        <Text size="medium" weight="medium">
          {t('Boost your listing')}
        </Text>
        <Badge tone="positive">{t('ACTIVE')}</Badge>
      </TitleContainer>
      <Text>
        {t('l.listing.view.sponsored_days_remaining.text', {
          defaultValue: 'Your sponsored listing ends in {{remainingDays}} days.',
          remainingDays
        })}
        &nbsp;
        <TextLinkButton onClick={showModal('sponsoredListing')} weight="regular">
          {t('Boost again')}
        </TextLinkButton>
      </Text>
    </InsightBlock>
  )
}
